import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { CargueReprogramacionComponent } from './CargueReprogramacion.component';

import { RoleGuardService as RoleGuard } from '../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'CargueReprogramacion',
        component: CargueReprogramacionComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'CargueReprogramacion',
          nombreFormulario : 'Cargue Reprogramacion'
        } 
    }
];

@NgModule({
    declarations: [
        CargueReprogramacionComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        CargueReprogramacionComponent
    ],
    bootstrap: [CargueReprogramacionComponent]
})

export class CargueReprogramacionModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CargueReprogramacion/CargueReprogramacion.module.ts